var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.75H4.5V0.75H16.5V4.75ZM16.5 10.25C16.7833 10.25 17.0208 10.1542 17.2125 9.9625C17.4042 9.77083 17.5 9.53333 17.5 9.25C17.5 8.96667 17.4042 8.72917 17.2125 8.5375C17.0208 8.34583 16.7833 8.25 16.5 8.25C16.2167 8.25 15.9792 8.34583 15.7875 8.5375C15.5958 8.72917 15.5 8.96667 15.5 9.25C15.5 9.53333 15.5958 9.77083 15.7875 9.9625C15.9792 10.1542 16.2167 10.25 16.5 10.25ZM14.5 16.75V12.75H6.5V16.75H14.5ZM16.5 18.75H4.5V14.75H0.5V8.75C0.5 7.9 0.791667 7.1875 1.375 6.6125C1.95833 6.0375 2.66667 5.75 3.5 5.75H17.5C18.35 5.75 19.0625 6.0375 19.6375 6.6125C20.2125 7.1875 20.5 7.9 20.5 8.75V14.75H16.5V18.75Z",
    fill: "#08BA36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.cdbc4584ee1e0bb8230400eb5b5f82f0.svg";
export { ForwardRef as ReactComponent };